const ZERO_DECIMAL_CURRENCIES = new Set([
  'bif', 'clp', 'djf', 'gnf', 'isk', 'jpy', 'kmf', 'krw',
  'mga', 'pyg', 'rwf', 'ugx', 'vnd', 'vuv', 'xaf', 'xof', 'xpf'
])

export const getDecimalPlaces = (currency) => {
  return ZERO_DECIMAL_CURRENCIES.has((currency || 'usd').toLowerCase()) ? 0 : 2
}

export const formatPrice = (amount, currency) => {
  const decimals = getDecimalPlaces(currency)
  const n = Number(amount)
  if (isNaN(n) || !isFinite(n)) {
    return decimals === 0 ? '0' : '0.00'
  }
  return n.toFixed(decimals)
}

// Lightweight symbol map covering the currencies Acta publishers use.
// Mirrors the backend formattedCurrencies() logic without pulling in
// the currency-symbol-map npm package.
const SYMBOL_MAP = {
  usd: '$',
  eur: '\u20AC',
  gbp: '\u00A3',
  jpy: '\u00A5',
  cny: '\u00A5',
  krw: '\u20A9',
  inr: '\u20B9',
  try: '\u20BA',
  rub: '\u20BD',
  brl: 'R$',
  zar: 'R',
  mxn: 'MX$',
  aud: 'A$',
  cad: 'CA$',
  nzd: 'NZ$',
  sgd: 'S$',
  hkd: 'HK$',
  chf: 'CHF',
  sek: 'kr',
  nok: 'kr',
  dkk: 'kr',
  pln: 'z\u0142',
  czk: 'K\u010D',
  huf: 'HUF',
  ils: '\u20AA',
  thb: '\u0E3F',
  php: '\u20B1',
  myr: 'RM',
  idr: 'Rp',
  vnd: '\u20AB',
  clp: 'CLP',
  cop: 'COL$',
  pen: 'S/.',
  ars: 'AR$',
  aed: 'AED',
  sar: 'SAR',
  ngn: '\u20A6',
  kes: 'KSh',
  egp: 'E\u00A3',
  pkr: 'Rs',
  bdt: '\u09F3',
  lkr: 'Rs',
  ghc: 'GH\u20B5',
  rwf: 'RF',
  ugx: 'USh',
  xaf: 'FCFA',
  xof: 'CFA',
}

/**
 * Return a display-ready currency symbol / prefix for the given ISO code.
 * Mirrors the backend formattedCurrencies() behaviour:
 *   - Letter-based symbols get uppercased + trailing space  (e.g. "CHF ")
 *   - "$" for non-USD currencies gets a country prefix       (e.g. "AU$")
 *   - Pure symbol currencies return the symbol as-is          (e.g. "$")
 * Falls back to "CODE " (uppercased) when the code is unknown.
 */
export const getCurrencySymbol = (currency) => {
  const code = (currency || 'usd').toLowerCase()
  const sym = SYMBOL_MAP[code]

  if (!sym) {
    return code.toUpperCase() + ' '
  }

  const isLetters = /[a-zA-Z]/.test(sym)
  if (isLetters) {
    return sym.toUpperCase() + ' '
  }

  if (sym === '$' && code !== 'usd') {
    return code.slice(0, 2).toUpperCase() + sym
  }

  return sym
}
